
            import { createI18n } from '@/node_modules/vue-i18n';            
            
            export default defineNuxtPlugin(({ vueApp }) => {
              const i18n = createI18n({
                legacy: false,
                globalInjection: true,
                fallbackLocale: 'en',
                locale: 'en',
                messages: {
  "ko": {
    "download": "다운로드",
    "attendance": {
      "day": "{day}일",
      "dayReward1": "1, 3, 5일차",
      "dayReward2": "7일차",
      "day1Reward": "플키팀 테마",
      "day7Reward": "플키팀 테마 + 개근상 테마 및 뱃지",
      "calenderTitle1": "뉴-플키러에게 <span class=\"highlight\">개근상</span>을 🎉",
      "calenderTitle2": "출석체크하고<br /><span class=\"highlight\">플키팀 테마</span> 받자!",
      "rewardInfoTitle": "출석도장만 찍어도<br /><span class=\"highlight\">플키팀 테마</span>와 <span class=\"highlight\">개근상 테마</span>를 선물해드려요.",
      "rewardInfoBody1": "<b>플키팀 테마</b> 중 원하는 테마 1종을 선택하세요!",
      "rewardInfoBody2": "<b>플키팀 테마</b> 지급은 물론<br>한정판 <b>개근상 테마</b>와 <b>뱃지</b>까지!<br><br><span style='font-size: 12px'>* 뱃지는 7일간 반영돼요.<br>이후엔 뉴-플키러 졸업! 🎓</span>",
      "rewardInfoButton1": "플키팀 테마 미리보기",
      "rewardInfoButton2": "개근상 테마 미리보기",
      "rewardTryBody1": "{day}일차 출석 보상이<br>도착했어요!",
      "rewardTryButton1": "테마 고르러 가기",
      "rewardTryBody2": "{day}일차 출석도장을 찍었어요.<br>내일 또 만나요!",
      "rewardTryButton2": "닫기",
      "rewardTry7DayBody": "개근 축하합니다 🎉<br>7일차 출석 보상이 도착했어요!",
      "rewardTry7DayButton": "테마 고르러가기",
      "rewardFinish7DayBody": "선택한 테마와 개근상 테마를<br>선물해드렸어요.",
      "rewardFinish7DayButton": "개근상 테마 다운받기",
      "rewardFinishBody": "선택한 테마를 선물해드렸어요.<br> 내일 또 만나요!",
      "rewardFinishButton": "테마 다운받기",
      "review": "출석체크 인증하기",
      "reviewPlaceholder": "댓글로 출석체크를 남겨봐요!",
      "reviewLike": "공감순",
      "reviewLatest": "최신순"
    },
    "theme-selector": {
      "designTheme": "일러스트 키보드",
      "expand": "테마 더보기",
      "title1": "원하는 <span class='highlight'>플키팀 테마</span>를 골라주세요!",
      "title2": "출석하면 얻을 수 있는<br><span class='highlight'>플키팀 테마</span>를 미리 구경해보세요!",
      "themeButton": "선택한 테마 고르기",
      "all": "전체",
      "light": "라이트",
      "vivid": "비비드",
      "dark": "다크",
      "live": "이모티콘",
      "my-theme": "MY테마",
      "diy-theme": "테마 만들기",
      "rate-us": "응원하기",
      "gem": "젬 충전하기",
      "setting": "키보드 설정",
      "recommend": "추천",
      "best": "인기",
      "simple": "심플",
      "cute": "귀여운",
      "colorful": "알록달록",
      "chic": "시크한",
      "emoji": "이모티콘",
      "collabo": "콜라보",
      "theme-subtitle": "{theme} 테마",
      "theme-more": "{theme} 테마 더보기",
      "liveDescription": "ⓘ 이모티콘 키보드는 배경 색상을 자유롭게 설정할 수 있어요.",
      "category": {
        "free": "무료",
        "set": "카톡테마 · 배경화면",
        "campaign": "캠페인",
        "christmas": "크리스마스"
      },
      "sort": {
        "featured": "맞춤추천순",
        "popularity": "인기순",
        "newest": "최신순"
      },
      "highOrderThemeName": "말랑쫀득 밀당이",
      "themeEmpty": "{'|'}￣￣￣￣￣￣￣￣￣￣￣￣￣￣{'|'}<br>선택한 필터의 테마가 없어요.<br>다른 카테고리를 둘러볼까요?<br>{'|'}＿＿＿＿＿/)  /)＿＿＿＿＿＿{'|'}<br>( ･ω･ {'|'}{'|'}<br>/⠀  つΦ"
    },
    "app-store": {
      "recommend": "오늘의 추천 테마",
      "tutorial": "원하는 테마를 손쉽게 찾아보세요!",
      "all": "내 취향 찾아보기",
      "popular": "급상승 유료 테마",
      "freePopular": "급상승 무료 테마",
      "review": "플키러들의 최신 리뷰",
      "view": "최근 본 테마",
      "reviewDefaultName": "익명의 플키러"
    },
    "review": {
      "anonymous": "익명의 플키러",
      "expandChildReview": "답글 {count}개 더보기",
      "childReviewPlaceholder": "{name}님에게 답글 남기기",
      "report": "댓글 신고하기",
      "block": "사용자 차단하기",
      "edit": "수정하기",
      "editSubmit": "수정",
      "remove": "삭제하기",
      "submit": "등록",
      "tooltip": {
        "image": "이제 이미지를 첨부할 수 있어요!"
      },
      "communityPolicy": "커뮤니티 운영 정책 확인하기",
      "recent": "최신 댓글 보기"
    },
    "event": {
      "review": "댓글",
      "quiz": "퀴즈",
      "daily": "일상",
      "story": "이야기",
      "plkey": "플키",
      "reply-edited": "편집됨",
      "goback": "뒤로가기",
      "reply": "답글 달기",
      "review-image": {
        "limit": "이미지는 최대 5장까지 첨부할 수 있어요."
      },
      "editing": "편집 중"
    },
    "hello": "안녕, {name}!",
    "theme-collecion": {
      "qr": {
        "title": "QR코드를 스캔하여 <br>플레이키보드 앱을 설치해주세요!",
        "description": "설치 후 키보드 테마가 적용돼요."
      }
    }
  },
  "en": {
    "download": "Download",
    "attendance": {
      "day": "Day {day}",
      "dayReward1": "Day 1, 3, 5",
      "dayReward2": "Day 7",
      "day1Reward": "PlayKeyboard team keyboard",
      "day7Reward": "PlayKeyboard team keyboard + Perfect Attendance Award keyboard and Badge",
      "calenderTitle1": "Perfect Attendance Award to <span class=\\\"highlight\\\">New–Buddy🎉</span>",
      "calenderTitle2": "Check attendance and Get PlayKeyboard team keyboard.",
      "rewardInfoTitle": "Even if you just take an attendance stamp, we will give you a PlayKeyboard team keyboard.",
      "rewardInfoBody1": "Choose one keyboard you want from the PlayKeyboard team keyboards!",
      "rewardInfoBody2": "Not only the <b>keyboard of the PlayKeyboard team,</b><br>but also <b>the limited edition perfect attendance award keyboard</b> and <b>badge!</b>",
      "rewardInfoButton1": "Preview of PlayKeyboard team keyboard",
      "rewardInfoButton2": "Preview of perfect Attendance Award keyboard",
      "rewardTryBody1": "Day {day} attendance reward has arrived!",
      "rewardTryButton1": "Go to choose a keyboard",
      "rewardTryBody2": "Day {day} Attendance is stamped. See you tomorrow!",
      "rewardTryButton2": "Quit",
      "rewardTry7DayBody": "Congratulations on your attendance🎉<br>Day 7 attendance reward has arrived!",
      "rewardTry7DayButton": "Choose the keyboard",
      "rewardFinish7DayBody": "We gave the selected keyboard and perfect attendance award keyboard as a present.",
      "rewardFinish7DayButton": "Download it",
      "rewardFinishBody": "We gave the selected keyboard as a present.<br>See you tomorrow!",
      "rewardFinishButton": "Download it",
      "review": "Attendance Certification",
      "reviewPlaceholder": "Leave your attendance check in the comments!",
      "reviewLike": "Like",
      "reviewLatest": "Newest"
    },
    "theme-selector": {
      "designTheme": "Design Keyboard",
      "expand": "View more",
      "title1": "Please choose<br><span class='highlight'>PlayKeyboard team keyboard</span> you want!",
      "title2": "Look around the keyboards<br>that you can get when you attend!",
      "themeButton": "Choose this keyboard",
      "all": "All",
      "light": "Light",
      "vivid": "Vivid",
      "dark": "Dark",
      "live": "Live",
      "my-theme": "MY Theme",
      "diy-theme": "DIY Theme",
      "rate-us": "Rate us",
      "gem": "Charging Gems",
      "setting": "Setting",
      "recommend": "Featured",
      "best": "Hot",
      "simple": "Simple",
      "cute": "Cute",
      "colorful": "Colorful",
      "chic": "Chic",
      "emoji": "Emoticon",
      "collabo": "Collabo",
      "theme-subtitle": "{theme} theme",
      "theme-more": "View more {theme} themes",
      "liveDescription": "ⓘ You can freely set the background color of the emoticon keyboard.",
      "category": {
        "free": "Free",
        "set": "카톡테마 · 배경화면",
        "campaign": "Campaign",
        "christmas": "Christmas"
      },
      "sort": {
        "featured": "Featured",
        "popularity": "Popularity",
        "newest": "Newest"
      },
      "highOrderThemeName": "Fluffy&Chewy Mildang",
      "themeEmpty": "{'|'}￣￣￣￣￣￣￣￣￣￣￣￣￣￣{'|'}<br>No themes for filters.<br>Browse other categories?<br>{'|'}＿＿＿＿＿/)  /)＿＿＿＿＿＿{'|'}<br>( ･ω･ {'|'}{'|'}<br>/⠀  つΦ"
    },
    "app-store": {
      "recommend": "Today's themes 😉",
      "tutorial": "Easily find the keyboard you want",
      "all": "Find my preference",
      "popular": "Paid keyboards on the rise",
      "freePopular": "Free keyboards on the rise",
      "review": "Latest Reviews",
      "view": "Recently Viewed Keyboards",
      "reviewDefaultName": "Anonymous user"
    },
    "review": {
      "anonymous": "Anonymous",
      "expandChildReview": "More {count} replies",
      "childReviewPlaceholder": "Reply to {name}'s comment",
      "report": "Report",
      "block": "Block",
      "edit": "Edit",
      "editSubmit": "Edit",
      "remove": "Delete",
      "submit": "Submit",
      "tooltip": {
        "image": "Now you can attach images!"
      },
      "communityPolicy": "Community Policy",
      "recent": "Recent Reviews"
    },
    "event": {
      "review": "Event Comment",
      "reply-edited": "Edited",
      "goback": "Back",
      "reply": "Reply",
      "review-image": {
        "limit": "You can attach up to 5 images."
      },
      "editing": "Editing"
    },
    "hello": "Hello, {name}!",
    "theme-collecion": {
      "qr": {
        "title": "Install the PlayKeyboard app!",
        "description": "After installation, the keyboard theme is applied."
      }
    }
  },
  "es": {
    "download": "Descargar",
    "attendance": {
      "day": "Día {day}",
      "dayReward1": "Día 1, 3, 5",
      "dayReward2": "Día 7",
      "day1Reward": "Tema del equipo PlayKeyboard",
      "day7Reward": "Tema del equipo PlayKeyboard + Tema e insignia del premio a la asistencia perfecta",
      "calenderTitle1": "Premio de Asistencia Perfecta a <span class=\\\"highlight\\\">New–Buddy🎉</span>",
      "calenderTitle2": "Compruebe la asistencia y obtenga el tema PlayKeyboard.",
      "rewardInfoTitle": "Aunque solo lleve un sello de asistencia, le regalaremos un tema de equipo PlayKeyboard.",
      "rewardInfoBody1": "¡Elija el tema que desee entre los temas del equipo PlayKeyboard!",
      "rewardInfoBody2": "No solo el <b>teclado del equipo de PlayKeyboard,</b><br>sino también el <b>teclado del premio de asistencia perfecta de edición limitada</b> y la <b>¡insignia!</b>",
      "rewardInfoButton1": "Vista previa del tema del equipo PlayKeyboard",
      "rewardInfoButton2": "Vista previa del tema del premio a la asistencia perfecta",
      "rewardTryBody1": "¡Ha llegado la recompensa de asistencia de {day}!",
      "rewardTryButton1": "Ir a elegir un teclado",
      "rewardTryBody2": "¡El premio de asistencia de {day} ha llegado!",
      "rewardTryButton2": "Quítate",
      "rewardTry7DayBody": "Felicidades por su asistencia🎉<br>¡Ha llegado el premio de asistencia del séptimo día!",
      "rewardTry7DayButton": "Elige el teclado,",
      "rewardFinish7DayBody": "Regalamos el tema seleccionado y el tema del premio de asistencia perfecta.",
      "rewardFinish7DayButton": "Descargalo",
      "rewardFinishBody": "Hemos regalado el tema seleccionado.<br>¡Hasta mañana!",
      "rewardFinishButton": "Descargalo",
      "review": "Certificación de asistencia",
      "reviewPlaceholder": "¡Deja tu cheque de asistencia en los comentarios!",
      "reviewLike": "Como",
      "reviewLatest": "El último"
    },
    "theme-selector": {
      "category": {},
      "sort": {}
    },
    "app-store": {
      "recommend": "Today's themes 😉",
      "tutorial": "Encuentre fácilmente el tema que desea",
      "all": "Buscar mi preferencia",
      "popular": "Temas de pago en alza",
      "freePopular": "Temas gratuitos en alza",
      "review": "Últimas revisiones",
      "view": "Teclados vistos recientemente",
      "reviewDefaultName": "Anónimo"
    },
    "review": {
      "anonymous": "Anónimo",
      "expandChildReview": "Más {count} respuestas",
      "childReviewPlaceholder": "Responder al comentario de {name}",
      "report": "Informe",
      "block": "Bloquear",
      "edit": "Editar",
      "editSubmit": "Editar",
      "remove": "Borrar",
      "submit": "Entregar",
      "tooltip": {
        "image": "¡Ahora puedes adjuntar imágenes!"
      }
    },
    "event": {
      "review": "Comentario de evento",
      "reply-edited": "Edited",
      "goback": "Back",
      "reply": "Reply",
      "review-image": {
        "limit": "Puedes adjuntar hasta 5 imágenes."
      },
      "editing": "Editing"
    },
    "hello": "¡Hola, {name}!",
    "theme-collecion": {
      "qr": {}
    }
  },
  "id": {
    "download": "Unduh",
    "attendance": {
      "day": "Hari {day}",
      "dayReward1": "Hari ke 1, 3, 5",
      "dayReward2": "Hari ke 7",
      "day1Reward": "Papan tik tim PlayKeyboard",
      "day7Reward": "Papan tik tim PlayKeyboard + Papan ketik dan lencana untuk pembukaan kelas",
      "calenderTitle1": "Penghargaan Kehadiran Sempurna bagi Pengguna <span class=\\\"highlight\\\">New–Buddy🎉</span>",
      "calenderTitle2": "Periksa kehadiran dan Dapatkan tema PlayKeyboard.",
      "rewardInfoTitle": "Jika Anda muncul, saya akan memberi Anda papan ketik sebagai hadiah.",
      "rewardInfoBody1": "Pilih satu keyboard yang Anda inginkan dari keyboard tim PlayKeyboard!",
      "rewardInfoBody2": "Tidak hanya <b>keyboard tim PlayKeyboard,</b><br>tetapi juga <b>Keyboard Penghargaan Kehadiran Sempurna Edisi Terbatas</b> dan <b>lencana!</b>",
      "rewardInfoButton1": "Pratilik papan tik tim PlayKeyboard",
      "rewardInfoButton2": "Pratilik papan tik Penghargaan Kehadiran sempurna",
      "rewardTryBody1": "Hadiah kehadiran {day} telah tiba!",
      "rewardTryButton1": "Memilih papan tik",
      "rewardTryBody2": "Kehadiran {day} telah distempel. Sampai jumpa lagi besok!",
      "rewardTryButton2": "Berhenti",
      "rewardTry7DayBody": "Felicidades por su asistencia🎉<br>¡Ha llegado el premio de asistencia del séptimo día!",
      "rewardTry7DayButton": "Elige el teclado,",
      "rewardFinish7DayBody": "Regalamos el tema seleccionado y el tema del premio de asistencia perfecta.",
      "rewardFinish7DayButton": "Unduh itu",
      "rewardFinishBody": "Saya memberi Anda papan ketik pilihan Anda.<br>Sampai jumpa lagi besok!",
      "rewardFinishButton": "Unduh itu",
      "review": "Sertifikasi Kehadiran",
      "reviewPlaceholder": "Tinggalkan cek kehadiran Anda di komentar!",
      "reviewLike": "Menyukai",
      "reviewLatest": "Terbaru"
    },
    "theme-selector": {
      "category": {},
      "sort": {}
    },
    "app-store": {
      "recommend": "Today's themes 😉",
      "tutorial": "Temukan tema yang Anda inginkan dengan mudah",
      "all": "Temukan preferensi saya",
      "popular": "Meroket pembayaran",
      "freePopular": "Tema bebas berkembang",
      "review": "Ulasan Terbaru",
      "view": "Papan Ketik yang Baru Dilihat",
      "reviewDefaultName": "Tanpa Nama"
    },
    "review": {
      "anonymous": "Tanpa Nama",
      "expandChildReview": "Lebih banyak {count} balasan",
      "childReviewPlaceholder": "Balas ke komentar {name}",
      "report": "Laporan",
      "block": "Blokir",
      "edit": "Sunting",
      "editSubmit": "Sunting",
      "remove": "Menghapus",
      "submit": "Kirim",
      "tooltip": {
        "image": "Sekarang Anda dapat melampirkan gambar!"
      }
    },
    "event": {
      "review": "Komentar Peristiwa",
      "reply-edited": "Edited",
      "goback": "Back",
      "reply": "Reply",
      "review-image": {
        "limit": "Anda dapat mengunggah hingga 5 gambar."
      },
      "editing": "Editing"
    },
    "hello": "Halo, {name}!",
    "theme-collecion": {
      "qr": {}
    }
  }
},
              });
            
              vueApp.use(i18n);
            });